module.exports = __webpack_public_path__ + "static/media/3.f4ff88c5.jpg";